import {useQuery} from "react-query";
import RateApi from "./Rates.api";

export function useRates(query:any){
    return useQuery(["fetchRates", query], RateApi.getData);
}